// components/StationLegendSection.js
import React from 'react';
import { Typography, Box, Grid } from '@mui/material';

function StationLegendSection({ title, items }) {
    return (
        <Box sx={{ mb: 4 }}>
            <Typography variant="h5" fontWeight="medium" gutterBottom>
                {title}
            </Typography>
            <Grid container spacing={2}>
                {items.map((item) => (
                    <Grid item xs={12} sm={6} md={4} key={item.name}>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <Box
                                component="img"
                                src={item.image}
                                alt={item.name}
                                sx={{
                                    width: 70,
                                    height: 70,
                                    mr: 2,
                                    borderRadius: 2,
                                    objectFit: 'contain',
                                    bgcolor: 'white',
                                    p: 1,
                                }}
                            />

                            <Box>
                                <Typography variant="subtitle1" fontWeight="bold">
                                    {item.name}
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    {item.description}
                                </Typography>
                            </Box>
                        </Box>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
}

export default StationLegendSection;
